(() => {
  const DESKTOP_MIN = 960;
  const GAP = 20;

  function perView() {
    return window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches ? 3 : 1;
  }

  function initCarousel(root) {
    if (root.dataset.laReasonsReady === 'true') return;

    const viewport = root.querySelector('[data-la-reasons-viewport]');
    const track = root.querySelector('[data-la-reasons-track]');
    const cards = [...root.querySelectorAll('[data-la-reasons-card]')];
    const prev = root.querySelector('[data-la-reasons-prev]');
    const next = root.querySelector('[data-la-reasons-next]');
    const dotsWrap = root.querySelector('[data-la-reasons-dots]');
    if (!viewport || !track || !cards.length || !dotsWrap) return;

    root.dataset.laReasonsReady = 'true';

    let page = 0;
    let pageCount = 1;
    let view = perView();

    function measure() {
      view = perView();
      pageCount = Math.max(1, Math.ceil(cards.length / view));
      page = Math.min(page, pageCount - 1);

      const viewportWidth = viewport.clientWidth;
      const cardWidth = Math.max(0, (viewportWidth - GAP * (view - 1)) / view);

      cards.forEach((card) => {
        card.style.width = `${cardWidth}px`;
        card.style.flexBasis = `${cardWidth}px`;
      });

      const offset = page * view * (cardWidth + GAP);
      track.style.transform = `translate3d(-${offset}px, 0, 0)`;

      renderDots();
      syncControls();
    }

    function renderDots() {
      const existing = [...dotsWrap.querySelectorAll('[data-la-reasons-dot]')];
      if (existing.length !== pageCount) {
        dotsWrap.innerHTML = '';
        for (let i = 0; i < pageCount; i += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'la-reasons__dot';
          button.setAttribute('data-la-reasons-dot', '');
          button.setAttribute('aria-label', `Go to slide ${i + 1}`);
          button.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(button);
        }
      }

      [...dotsWrap.querySelectorAll('[data-la-reasons-dot]')].forEach((dot, index) => {
        const active = index === page;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    function syncControls() {
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= pageCount - 1;
    }

    function goTo(nextPage) {
      page = Math.max(0, Math.min(pageCount - 1, nextPage));
      measure();
    }

    prev?.addEventListener('click', () => goTo(page - 1));
    next?.addEventListener('click', () => goTo(page + 1));

    let touchStartX = 0;
    let touchDeltaX = 0;

    viewport.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      (event) => {
        touchDeltaX = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      () => {
        if (Math.abs(touchDeltaX) < 40) return;
        goTo(touchDeltaX < 0 ? page + 1 : page - 1);
      },
      { passive: true }
    );

    const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null;
    resizeObserver?.observe(viewport);
    window.addEventListener('resize', measure);

    measure();
  }

  function init(scope) {
    const roots = (scope || document).querySelectorAll?.('[data-la-reasons]') || [];
    roots.forEach(initCarousel);
    if (scope?.matches?.('[data-la-reasons]')) initCarousel(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-la-reasons]') || event.target.closest?.('[data-la-reasons]');
    if (!root) return;
    delete root.dataset.laReasonsReady;
    initCarousel(root);
  });
})();
